import { NavRoute, DeployRoute } from 'application/types/routes';

import { useAPI } from 'hooks/api/useAPI';
import { useCurrentPlan } from 'organizations/hooks/useCurrentPlan';

import { Button } from 'components/Button/Button';
import { Sidebar } from 'components/Sidebar/Sidebar';
import { SidebarLink } from 'components/Sidebar/SidebarLink';

export function DeploySidebar() {
  const { applicationID } = useAPI();
  const {
    data: currentPlan,
    isSuccess,
    isSimplifiedUxPlan,
    isRingPlan,
  } = useCurrentPlan();

  const canUseTrackables =
    (isSuccess && currentPlan === null) ||
    Boolean(currentPlan?.can_use_trackables);

  return (
    <Sidebar hasTagsTree>
      {!isRingPlan && (
        <SidebarLink
          to={`/${NavRoute.DEPLOY}/${DeployRoute.GATEWAYS}`}
          icon="gateway"
          keepSearchParams
        >
          Gateways
        </SidebarLink>
      )}
      <SidebarLink
        to={`/${NavRoute.DEPLOY}/${DeployRoute.CAMERAS}`}
        icon="camera"
        keepSearchParams
      >
        Cameras
      </SidebarLink>
      {!isRingPlan && (
        <SidebarLink
          to={`/${NavRoute.DEPLOY}/${DeployRoute.STREAMS}`}
          icon="stream"
          keepSearchParams
        >
          Streams
        </SidebarLink>
      )}
      {!isSimplifiedUxPlan && (
        <SidebarLink
          to={`/${NavRoute.DEPLOY}/${DeployRoute.FILES}`}
          icon="file"
          keepSearchParams
        >
          Files
        </SidebarLink>
      )}
      {canUseTrackables && (
        <SidebarLink
          to={`/${NavRoute.DEPLOY}/${DeployRoute.TRACKABLES}`}
          icon="eye"
          keepSearchParams
        >
          Watchlists
        </SidebarLink>
      )}
      {!isSimplifiedUxPlan && (
        <SidebarLink
          to={`/${NavRoute.DEPLOY}/${DeployRoute.DEPLOYMENTS}`}
          icon="deployment"
          keepSearchParams
        >
          Workflow deployments
        </SidebarLink>
      )}
      {!isRingPlan && (
        <SidebarLink
          to={`/${NavRoute.DEPLOY}/${DeployRoute.EVENTS}`}
          icon="event"
        >
          Events
        </SidebarLink>
      )}

      <Button
        to={`/applications/${applicationID}/${NavRoute.DEPLOY}/${DeployRoute.RAPID_DEPLOY}`}
        variant="primary"
        size="small"
      >
        Deploy workflows
      </Button>
    </Sidebar>
  );
}
